import informative from '@ingka/ssr-icon/paths/information-circle';
import cautionary from '@ingka/ssr-icon/paths/warning-triangle';
import positive from '@ingka/ssr-icon/paths/checkmark-circle';
import negative from '@ingka/ssr-icon/paths/cross-circle';
import { ReactNode } from 'react';
import InlineMessage from '@ingka/inline-message';

type MessageProps = {
  children: ReactNode;
  variant?: 'informative' | 'positive' | 'cautionary' | 'negative';
  subtle?: boolean;
  role?: string;
  id?: string;
};

const Message = ({
  children,
  variant = 'informative',
  subtle = false,
  role,
  id,
}: MessageProps) => {
  const iconMap = {
    cautionary,
    informative,
    positive,
    negative,
  };

  return (
    <div id={id} role={role} aria-live={role === 'alert' ? 'assertive' : role === 'status' ? 'polite' : undefined}>
      <InlineMessage
        body={<span>{children}</span>}
        variant={variant}
        ssrIcon={iconMap[variant]}
        subtle={subtle}
      />
    </div>
  );
};

export default Message;